import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Column, ColumnGroup } from '@cards/Card';
import PathwayStagesTableCard from '@pathways/cards/Pathways/PathwayStagesTable';
import EngagementChecksCard from '@pathways/cards/Pathways/EngagementChecks';
import IndexEventTriggeredRulesCard from '@pathways/cards/Pathways/IndexEventTriggeredRules';
import PathwayDetailsCard from '@pathways/cards/Pathways/PathwayDetails/Card';

export default ({ pathway, isSharedPathway }) => {
  const history = useHistory();
  const match = useRouteMatch();

  if (!pathway) {
    return null;
  }

  return (
    <>
      <ColumnGroup>
        <Column>
          <PathwayStagesTableCard
            pathwayId={pathway.id}
            history={history}
            match={match}
            sharedPathway={isSharedPathway ? pathway : null}
          />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <EngagementChecksCard
            pathwayId={pathway.id}
            disabled={pathway?.isReadOnly}
            isSharedPathway={isSharedPathway}
          />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <IndexEventTriggeredRulesCard pathwayId={pathway.id} />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <PathwayDetailsCard pathway={pathway} />
        </Column>
        <Column />
      </ColumnGroup>
    </>
  );
};
